export const internalNotificationPath = value => {
  if (!value) return "";
  try {
    const parsed = new URL(value, window.location.origin);
    return parsed.pathname + parsed.search + parsed.hash;
  } catch { return ""; }
};

export const matchDetailPath = notification => {
  const metadata = notification.metadata || {};
  if (notification.type === "card_match_found" && metadata.matchedUserId) {
    const params = new URLSearchParams({ tab: "binder" });
    if (metadata.matchedUserCardId) params.set("card", metadata.matchedUserCardId);
    if (metadata.matchedCollectionId) params.set("collection", metadata.matchedCollectionId);
    return "/u/" + encodeURIComponent(metadata.matchedUserId) + "?" + params;
  }
  if (notification.type === "card_wanted_match" && metadata.seekerUserId) {
    const wanted = String(metadata.wantedUserCardId || "");
    const params = new URLSearchParams({ tab: wanted.startsWith("set-missing:") ? "binder" : "wanted" });
    if (wanted.startsWith("set-missing:")) {
      const parts = wanted.split(":");
      if (parts.length === 3) { params.set("collection", parts[1]); params.set("card", parts[2]); }
      else return internalNotificationPath(metadata.url) || "/u/" + encodeURIComponent(metadata.seekerUserId) + "?tab=binder";
    } else if (wanted) params.set("card", wanted);
    return "/u/" + encodeURIComponent(metadata.seekerUserId) + "?" + params;
  }
  return internalNotificationPath(metadata.url);
};

export const matchProposalPath = notification => {
  const metadata = notification.metadata || {};
  const offering = notification.type === "card_wanted_match";
  const person = offering ? metadata.seekerUserId : metadata.matchedUserId || metadata.receiverId;
  if (!person || !metadata.matchedUserCardId) return "";
  return "/trades?" + new URLSearchParams({ tab: "matches", person, card: metadata.matchedUserCardId, intent: offering ? "offer" : "request" });
};
